import { useCallback } from 'react'

import { useAuth } from '@/context/authContext'
import { Role } from '@/modules/adminUsers/roles'

export const useRoles = () => {
  const { roles, isLoaded } = useAuth()

  const hasRole = useCallback(
    (rolesToCheck: Role[], trueWhileLoading = false) => {
      if (trueWhileLoading && !isLoaded) return true

      return rolesToCheck.some((r) => roles?.includes(r))
    },
    [roles, isLoaded]
  )

  return { loading: isLoaded, roles, hasRole }
}

/**
 * @deprecated use the `useHasRoles` hook instead, it's nicer
 */
export const hasRole = (roles = ['super-admin'] as Role[], userRoles) =>
  roles.some((r) => userRoles.includes(r))
